import { render, staticRenderFns } from "./tickerCard.vue?vue&type=template&id=4893c4d4&scoped=true&"
import script from "./tickerCard.vue?vue&type=script&lang=js&"
export * from "./tickerCard.vue?vue&type=script&lang=js&"
import style0 from "./tickerCard.vue?vue&type=style&index=0&id=4893c4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4893c4d4",
  null
  
)

export default component.exports